import React from 'react';
import { DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import dayjs from 'dayjs';

interface DateTimePickerProps {
  value?: Date | null;
  isEdit?: boolean;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  isEdit = false,
  onChange,
  placeholder = 'Select date & time',
  minDate,
  maxDate,
  className,
}) => {
  const handleChange: DatePickerProps['onChange'] = (date) => {
    onChange(date ? date.toDate() : null);
  };

  return (
    <>
    {isEdit ? 
      <DatePicker
      showTime={{ format: 'HH:mm' }}
      format="YYYY-MM-DD HH:mm"
      placeholder={placeholder}
      className={className}
      getPopupContainer={(trigger) => trigger.parentElement!}
      value={value ? dayjs(value) : null}
      onChange={handleChange}
      disabledDate={(current) => {
        if (!current) return false;
        const beforeMin = minDate && current.isBefore(dayjs(minDate), 'minute');
        const afterMax = maxDate && current.isAfter(dayjs(maxDate), 'minute');
        return !!(beforeMin || afterMax); // ✅ Ensures return is boolean
      }}
    />      : 
<DatePicker
      showTime={{ format: 'HH:mm' }}
      format="YYYY-MM-DD HH:mm"
      placeholder={placeholder}
      className={className}
      getPopupContainer={(trigger) => trigger.parentElement!}
      onChange={handleChange}
      disabledDate={(current) => {
        if (!current) return false;
        const beforeMin = minDate && current.isBefore(dayjs(minDate), 'minute');
        const afterMax = maxDate && current.isAfter(dayjs(maxDate), 'minute');
        return !!(beforeMin || afterMax); // ✅ Ensures return is boolean
      }}
    />
  }
    </>
  );
};

export default DateTimePicker;
